﻿

export function projectStatus() {
  var moveX =  document.querySelector(".project-status-steps").querySelector(".active").offsetLeft;
  document.querySelector(".project-status-wrapper").scrollLeft = moveX;
}